import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import React from "react";
import { CHECK_ICON } from "../../utils/svgs_new";
import { AppIcon } from "./AppIcon";

const CheckboxRoot = styled(CheckboxPrimitive.Root)``;

const Checkbox = (
  props: React.ComponentProps<typeof CheckboxRoot>,
  ref: React.Ref<HTMLButtonElement>
) => (
  <Checkbox.Root {...props} ref={ref}>
    <AppIcon icon={CHECK_ICON} size={10} />
  </Checkbox.Root>
);

const checkboxAnimation = keyframes`
    from { transform: scale(0.7); opacity: 0; }
`;

Checkbox.Root = styled(CheckboxRoot)`
  --size: 24px;
  --radius: 4px;
  width: var(--size);
  height: var(--size);
  border-radius: var(--radius);
  background-color: var(--primary-soft-color);
  border: 2px solid var(--primary-color);
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 150ms ease;

  .AppIcon {
    flex-shrink: 0;
  }

  &[data-state="checked"] {
    background-color: var(--primary-color);

    &:disabled {
      opacity: 0.3;
    }

    .AppIcon path {
      stroke: #fff;
    }
  }

  &[data-state="unchecked"] {
    &:disabled {
      background-color: var(--gray-50);
      border-color: var(--gray-100);
    }

    .AppIcon path {
      stroke: transparent;
    }
  }

  &[aria-invalid="true"] {
    background-color: var(--red-soft);
    border-color: var(--red);
  }
`;

Checkbox.Indicator = styled(CheckboxPrimitive.Indicator)`
  /* color: violet.violet11 */
  background-color: var(--primary-color);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  display: block;
  border-radius: var(--radius);
  animation: ${checkboxAnimation} 0.2s cubic-bezier(0.2, 1.15, 0.35, 1.15);
  box-shadow: 0 0 0 2px var(--primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default React.forwardRef(Checkbox);
